import { H1 } from '@unistocks/components/text/text';
import { styled } from 'tamagui';

export const PAGE_HEADING_NAME = 'PageHeading';

export const PageHeading = styled(H1, {
  name: PAGE_HEADING_NAME,
  size: '$8',
  color: '$headingFont',
  userSelect: 'none'
});
